import React from 'react';
import { Buffer } from 'buffer';
// import crypto from 'crypto';
import CryptoJS from 'crypto-js';

const that = {}
const alphabet = []

export default function bufferToString(arrayBuffer) {
  var result = "";
			var i = 0;
			var c = 0;
			var c1 = 0;
			var c2 = 0;	
			var c3 = 0;		
			var data = new Int8Array(arrayBuffer);
			// If we have a BOM skip it
			if (data.length >= 3 && data[0] === 0xef && data[1] === 0xbb && data[2] === 0xbf) {
				i = 3;
			}
			while (i < data.length) {
				c = data[i];
				if (c < 128) {
					result += String.fromCharCode(c);
					i++;
				} else if (c > 191 && c < 224) {
					if( i+1 >= data.length ) {
						throw "UTF-8 Decode failed. Two byte character was truncated.";
					}
					c2 = data[i+1];
					result += String.fromCharCode( ((c&31)<<6) | (c2&63) );
					i += 2;
				} else {
					if (i+2 >= data.length) {
						throw "UTF-8 Decode failed. Multi byte character was truncated.";
					}
					c2 = data[i+1];
					c3 = data[i+2];
					result += String.fromCharCode( ((c&15)<<12) | ((c2&63)<<6) | (c3&63) );
					i += 3;
				}
			}
			
			return result;
}

export  function btoa(obj) {
  var string = JSON.stringify(obj);
			return CryptoJS.AES.encrypt(string,process.env.REACT_APP_API_KEY).toString();
}
export  function encryptConsole(obj) {
	var string = JSON.stringify(obj);
			
			  return CryptoJS.AES.encrypt(string,process.env.REACT_APP_API_KEY).toString();
  }

export  function atob (obj) {
  try{
	var string = CryptoJS.AES.decrypt(obj.toString(),process.env.REACT_APP_API_KEY).toString(CryptoJS.enc.Utf8);
	string = JSON.parse(string);
	return string;
  }catch(e){
	return []
  }
}
export  function decryptConsole (obj) {
	var string = CryptoJS.AES.decrypt(obj.toString(),process.env.REACT_APP_API_KEY).toString(CryptoJS.enc.Utf8);

	try{
	  string = JSON.parse(string);
	}catch(ex){

	  string = [];
	}
	return string;
  }

export function toUnicode(str) {
  return str.split('').map(function (value, index, array) {
    var temp = value.charCodeAt(0).toString(16).toUpperCase();
    if (temp.length > 2) {
      return '\\u' + temp;
    }
    return value;
  }).join('');
}



var Encoder = () => {
	var skip = 0 // how many bits we will skip from the first byte
	var bits = 0 // 5 high bits, carry from one byte to the next

	that.output = ''

	// Read one byte of input
	// Should not really be used except by "update"
	that.readByte = function(byte) {
		// coerce the byte to an int
		if (typeof byte === 'string') byte = byte.charCodeAt(0)

		if (skip < 0) { // we have a carry from the previous byte
			bits |= (byte >> (-skip))
		} else { // no carry
			bits = (byte << skip) & 248
		}

		if (skip > 3) {
			// not enough data to produce a character, get us another one
			skip -= 8
			return 1
		}

		if (skip < 4) {
			// produce a character
			that.output += alphabet[bits >> 3]
			skip += 5
		}

		return 0
	}

	// Flush any remaining bits left in the stream
	that.finish = function(check) {
		var output = that.output + (skip < 0 ? alphabet[bits >> 3] : '') + (check ? '$' : '')
		that.output = ''
		return output
	}
}
Encoder.update = function(input, flush) {
	for (var i = 0; i < input.length; ) {
		i += that.readByte(input[i])
	}
	// consume all output
	var output = that.output
	that.output = ''
	if (flush) {
	  output += that.finish()
	}
	return output
}
export function encode(input) {
	var encoder = new Encoder()
	var output = encoder.update(input, true)
	return output
  }


// export default DecryptData